module.exports = __webpack_public_path__ + "static/media/F6.cab19743.mp3";